var generateStyle = function generateStyle(componentTheme) {
  return {
    distractorsContainer: {
      display: 'flex',
      flexDirection: 'column'
    },
    addButtonText: {
      padding: componentTheme.addButtonTextPadding,
      fontSize: componentTheme.addButtonTextSize
    },
    additionalDistractorText: {
      paddingTop: componentTheme.distractorPaddingTop,
      paddingRight: componentTheme.distractorPaddingRight
    }
  };
};
export default generateStyle;